import { FAQJsonLd } from 'gatsby-plugin-next-seo'
import { useMobile } from 'src/hooks/useMobile'
import IconHasNoClube from 'src/components/Icons/IconHasNoClube'
import IconHasClube from 'src/components/Icons/IconHasClube'
import { makeEventTrack, sendEvent } from 'src/utils/restructure/analytics'
import { removeHtmlFromString } from 'src/utils/removeHtmlFromString'

import TiersMobile from './TiersMobile'
import DoubtsModalClub from './DoubtsModalClub'
import type { MockTiersProps } from './TableTiers'

import '../clubeStyles.scss'

const TableTiersClub = ({
  title,
  tiers,
  bottomSpan,
  tiersButton,
  tiersButtonLink,
  doubtsArr,
}: MockTiersProps) => {
  const { isMobile } = useMobile()

  const createAccountEvent = makeEventTrack({
    eventAction: `create_account`,
    eventPage: 'clube decathlon',
  })

  const faqJson =
    doubtsArr?.items
      .filter((item) => item.active)
      .map((item) => ({
        question: item.question,
        answer: removeHtmlFromString(item.response),
      })) ?? []

  return (
    <div className="WrapTiersClub w-full font-inter px-[18px] md:px-0">
      <div className="headeDivTiers flex justify-between w-full max-w-[1285px] mx-auto mb-[24px] md:mb-[100px]">
        <h2
          className="text-[#101010] font-medium text-2xl max-w-[330px] md:text-[32px] md:max-w-full"
          dangerouslySetInnerHTML={{ __html: title }}
        />

        <FAQJsonLd questions={faqJson} />
        {!isMobile ? (
          <DoubtsModalClub renderFaqSchema={false} doubtsArr={doubtsArr} />
        ) : (
          ''
        )}
      </div>

      {isMobile ? (
        <TiersMobile mockProps={tiers} />
      ) : (
        <div className="WrapperTiersClub w-full max-w-[1285px] mx-auto">
          <div className="tableTiersClub mb-[36px]">
            <div className="tableTiersHead flex w-full ">
              <div className="bnftsHeadLeft flex flex-col justify-end pt-[75px] px-[16px] pb-[16px] w-[24%] border-b border-b-[#D9DDE1]">
                <div className="block h-[80px] mb-[24px]">
                  <p className="block font-semibold my-auto text-base">
                    Benefícios exclusivos
                  </p>
                </div>
                {tiers[0].benefits.map((bfts, idx) =>
                  bfts.value ? (
                    <p className="text-base py-[8px] truncate" key={idx}>
                      {bfts.label}
                    </p>
                  ) : (
                    ''
                  )
                )}
              </div>
              {tiers.map((items, idx) => (
                <div
                  className="bnftsHeadRight block w-[25.5%] px-[16px] pb-[16px] border-l border-b border-l-[#D9DDE1] border-b-[#D9DDE1]"
                  key={idx}
                >
                  <img
                    className="mb-[12px]"
                    src={items.icon}
                    alt={items.name}
                  />
                  <p className="font-semibold text-[18px] mb-[12px]">
                    {items.name}
                  </p>
                  <div className="excBnft p-[16px] border border-[#D9DDE1] mb-[24px]">
                    <p
                      className="text-xs"
                      dangerouslySetInnerHTML={{ __html: items.ruleText }}
                    />
                  </div>
                  {items.benefits.map((bfts, idxs) =>
                    bfts.enableIcon && bfts.value ? (
                      <p
                        key={idxs}
                        className="text-base py-[8px] font-semibold text-center"
                      >
                        {bfts.statusIcon ? (
                          <IconHasClube className="block mx-auto" />
                        ) : (
                          <IconHasNoClube className="block mx-auto" />
                        )}
                      </p>
                    ) : bfts.description ? (
                      <p
                        key={idxs}
                        className="text-base py-[8px] font-semibold text-center"
                      >
                        {bfts.description}
                      </p>
                    ) : (
                      ''
                    )
                  )}
                </div>
              ))}
            </div>

            <div className="tableTiersBottom flex w-full">
              <div className="bnftsBottomLeft pt-[14px] px-[16px] pb-[16px] w-[24%] border-b border-b-[#D9DDE1]">
                {tiers[0].benefits.map((bfts, idx) =>
                  !bfts.value ? (
                    <p className="text-base py-[8px] truncate" key={idx}>
                      {bfts.label}
                    </p>
                  ) : (
                    ''
                  )
                )}
              </div>

              {tiers.map((items, idx) => (
                <div
                  key={idx}
                  className="bnftsBottomRight pt-[14px] block w-[25.5%] px-[16px] pb-[16px] border-l border-b border-l-[#D9DDE1] border-b-[#D9DDE1]"
                >
                  {items.benefits.map((bfts, idxs) =>
                    bfts.enableIcon && !bfts.value ? (
                      <p
                        key={idxs}
                        className="text-base py-[8px] font-semibold text-center"
                      >
                        {bfts.statusIcon ? (
                          <IconHasClube className="block mx-auto" />
                        ) : (
                          <IconHasNoClube className="block mx-auto" />
                        )}
                      </p>
                    ) : (
                      ''
                    )
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      <div className="w-full max-w-[1285px] text-center mx-auto mt-[24px] md:mt-0">
        <span className="block mx-auto text-[#3E4751] text-xs text-center">
          {bottomSpan}
        </span>
      </div>

      <a
        onClick={() => sendEvent(createAccountEvent)}
        className="block mx-auto mt-[42px] md:mb-[160px] py-[18.5px] bg-[#3643BA] rounded-[360px] w-full max-w-[335px] text-center text-white font-semibold"
        href={tiersButtonLink}
      >
        {tiersButton}
      </a>

      {isMobile ? <DoubtsModalClub doubtsArr={doubtsArr} /> : ''}
    </div>
  )
}

export default TableTiersClub
